import * as React from "react"
import PropTypes from "prop-types"
import { Link } from "gatsby"
import Logo from '../images/logo.png'


const Header = ({ siteTitle }) => (
 
                    <header id="header">
                        <nav class="navbar navbar-expand navbar-fixed" style={{background:'white'}}>
                            <div class="container-fluid" style={{width: "80%"}}>
                                
                                <ul class="navbar-nav items">
                                    <ul class="navbar-nav action">
                                        <li class="nav-item ml-3">
                                            {/* <img src={Logo} style={{maxWidth:'51%'}} /> */}
                                        </li>
                                    </ul>
                                    <li class="nav-item dropdown">
                                        <a  class="nav-link"><Link to={'/'}>HOME</Link></a>
                                    </li>

                                    <li class="nav-item dropdown">
                                        <a style={{color:'black'}} href="#" class="nav-link">About Us</a>
                                        <ul class="dropdown-menu">
                                            <li class="nav-item dropdown">
                                                <Link class="nav-link" to={'/about/can-portfolio'}>CAN portfolio</Link>
                                                <Link class="nav-link" to={'/about/startup-sindh-program-details'}>Startup Sindh Program Details</Link>
                                                <Link class="nav-link" to={'/about-our-logo'}>About our Logo</Link>
                                            </li>
                                        </ul>
                                    </li>
                                          
                                    <li class="nav-item dropdown">
                                        <Link  style={{color:'black'}} class="nav-link" to={'/enterprise-sindh'}>Enterprise Sindh</Link>
                                    </li>

                                    <li class="nav-item dropdown">
                                        <Link  style={{color:'black'}} class="nav-link" to={'/innovate_sindh'}>Innovation Sindh</Link>
                                    </li>

                                    <li class="nav-item dropdown">
                                        <Link  style={{color:'black'}} class="nav-link" to={'/build-sindh'}>Build Sindh</Link>
                                    </li>

                                    <li class="nav-item dropdown">
                                        <a style={{color:'black'}} href="#" class="nav-link">Startup Sindh</a>
                                        <ul class="dropdown-menu">
                                            <li class="nav-item dropdown">
                                                <Link class="nav-link" to={'/startup-sindh/thematic_areas'}>Thematic Areas</Link>
                                                <Link class="nav-link" to={'/faqs'}>FAQs</Link>
                                            </li>
                                        </ul>
                                    </li>

                                    <li class="nav-item dropdown">
                                        <a style={{color:'black'}} href="#" class="nav-link">Tracks / Leads</a>
                                        <ul class="dropdown-menu">
                                            <li class="nav-item dropdown">
                                                <Link class="nav-link" to={'/tracks-leads/funding-orgnization'}>Funding Organization</Link>
                                                <Link class="nav-link" to={'/tracks-leads/incubation-centers'}>Incubation Centers/Boot camps</Link>
                                                <Link class="nav-link" to={'/tracks-leads/training-centers'}>Universities/Training centers</Link>
                                                <Link class="nav-link" to={'/tracks-leads/business-competitions'}>Business Competitions</Link>
                                            </li>
                                        </ul>
                                    </li>


                                    <li class="nav-item dropdown">
                                        <Link  style={{color:'black'}} class="nav-link" to={'/startup-ideas '}>Startup Ideas</Link>
                                        
                                        <ul class="dropdown-menu">
                                            <li class="nav-item dropdown">
                                                <Link class="nav-link" to={'/startup-ideas/startup-sindh'}>Startup Sindh </Link>        
                                                <Link class="nav-link" to={'/startup-ideas/smallscale'}>Small Scale </Link>
                                                <Link class="nav-link" to={'/startup-ideas/medscale'}> Medium Scale </Link>
                                                <Link class="nav-link" to={'/startup-ideas/largescale'}> Large Scale </Link>
                                            </li>
                                        </ul>
                                    </li>


                                    <li class="nav-item dropdown">
                                        <a style={{color:'black'}} href="#" class="nav-link">Resources</a>
                                        <ul class="dropdown-menu">
                                            <li class="nav-item dropdown">
                                                <Link class="nav-link" to={'/resources/webinars'}>Webinars/Events</Link>
                                                <Link class="nav-link" to={'/resources/news'}>News</Link>
                                                <Link class="nav-link" to={'/resources/events'}>Events</Link>
                                            </li>
                                        </ul>
                                    </li>

                                    {/* <li class="nav-item dropdown">
                                        <a style={{color:'black'}} href="#" class="nav-link">News & Events</a>
                                        <ul class="dropdown-menu">
                                            <li class="nav-item dropdown">
                                                <Link class="nav-link" to={'/resources/webinars'}>Events</Link>
                                                <Link class="nav-link" to={'/resources/webinars'}>News</Link>
                                            </li>
                                        </ul>
                                    </li> */}

                                    <li class="nav-item dropdown">
                                        <a style={{color:'black'}} href="#" class="nav-link">Resource Library</a>
                                        <ul class="dropdown-menu">
                                            <Link  style={{color:'black'}} class="nav-link" to={'/blue_economy'}>District Overviews</Link>
                                            <Link  style={{color:'black'}} class="nav-link" to={'/reports-and-articles-on-districts'}>Reports and articles on districts</Link>
                                            <Link  style={{color:'black'}} class="nav-link" to={'/major-problems-and-limitations'}>Major problems and Limitations</Link>
                                            <Link  style={{color:'black'}} class="nav-link" to={'/needs-and-requirements'}>Needs and requirements</Link>
                                        </ul>
                                    </li>
                                </ul>

                                <ul class="navbar-nav action">
                                    <li class="nav-item ml-3">
                                        <Link href="#" to={'/contact_us'}  class="smooth-anchor btn ml-lg-auto primary-button">CONTACT US</Link>
                                    </li>
                                </ul>
                            </div>
                        </nav> 
                    </header>
)

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
